import CurrentSituationExcel from './view';

export default CurrentSituationExcel;
